<template>
  <div class="page-index">
    <!-- PC -->
    <swiper class="swiper" :options="swiperOption" ref="swiper">
      <swiper-slide>
        <div class="swiper-slide-one">
          <div class="content-one">
            <div class="logo"></div>
            <div class="close"></div>
            <div class="content"></div>
          </div>
          <div class="content-two">
            <p>电影《捞世界》</p>
            <p>数字藏品合成规则</p>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper-slide-two">
          <div class="content-one">
            <ul>
              <li v-for="(item, index) in 10" :key="index">
                <div :class="`photo-class` + (index + 1)"></div>
                <div>《捞世界-{{ index + 1 }}》</div>
              </li>
              <div class="description">
                <p>持有《捞世界》10款剧照 <br />就可以合成定档海报</p>
              </div>
            </ul>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper-slide-three">
          <div>
            <div class="content-one">
              <div class="arrows"></div>
              <div class="photo">
                <ul>
                  <li>
                    <div class="photo">
                      <div>《捞世界竖版海报—世界宝藏图》</div>
                    </div>
                  </li>
                  <li>
                    <div class="photo">
                      <div>《捞世界竖版海报—苦尽甘来发大财》</div>
                    </div>
                  </li>
                  <li>
                    <div class="photo">
                      <div>《捞世界竖版海报—不撤档》</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="content-two">
              <p>合成定档海报（三款任意一款）</p>
              <p>前80名合成者可获赠<span> 黄才伦签名版剧照</span></p>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/css/base.scss";
import "@/assets/css/rem/index.scss";
import "@/assets/css/rem/indexAdapter.scss";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        mousewheelControl: true,
        direction: "vertical",
        observer: true,

      },
    };
  },
};
</script>
<style lang="scss" scoped>
.swiper {
  background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/bg-one.jpg") no-repeat center center;
  background-size: cover;
height: 100vh;
}
.swiper-slide-one {
  height: 100vh;
  position: relative;

  .content-one {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 121px;
    .logo {
      width: 337px;
      height: 38px;
      background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/logo.png") no-repeat center center;
      background-size: cover;
      margin-right: 21px;
    }
    .close {
      width: 12px;
      height: 15px;
      background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/close.png") no-repeat center center;
      background-size: cover;
      margin-right: 22px;
    }
    .content {
      width: 155px;
      height: 54px;
      background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/content.png") no-repeat center center;
      background-size: cover;
    }
  }
  .content-two {
    font-size: 67px;
    font-weight: 800;
    color: #ffffff;
    line-height: 63px;
    text-align: center;
    p:nth-child(1) {
      margin-bottom: 28px;
    }
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.swiper-slide-two {
  height: 100vh;

  position: relative;
  .content-one {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 1200px;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    padding-top: 50px;
    padding-left: 80px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        display: flex;
        flex-direction: column;
        margin-right: 26px;
        margin-bottom: 30px;
        @for $i from 1 through 10 {
          .photo-class#{$i} {
            width: 251px;
            height: 137px;
            background: url("~@/assets/images/photo#{$i}.png") no-repeat center center;
            background-size: cover;
          }
        }
        div:nth-child(2) {
          text-align: right;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
        }
      }
    }
    .description {
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;
      margin-left: 94px;
      margin-top: 20px;
    }
  }
}
.swiper-slide-three {
  height: 100vh;
  position: relative;

  align-items: center;
  display: flex;
  flex-direction: column;
  .content-one {
    width: 1200px;
    display: flex;
    align-items: center;
    margin-top: 162px;
    height: 461px;
    .arrows {
      width: 111px;
      height: 95px;
      background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/three-left.png") no-repeat center center;
      background-size: cover;
      margin-right: 80px;
    }
    .photo {
      width: 850px;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 5px;
      position: relative;
      ul {
        display: flex;
        li {
          display: flex;
          flex-direction: column;
          .photo {
            width: 354px;
            height: 460px;
            background-size: cover;
            margin-right: -100px;
            div {
              position: absolute;
              left: 50%;
              bottom: 0px;
              transform: translate(-50%, 0px);
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              line-height: 35px;
              margin-bottom: 40px;
              white-space: nowrap;
            }
          }
        }
        li:nth-child(1) {
          .photo {
            background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/three-photo-one.png") no-repeat center
              center;
          }
        }
        li:nth-child(2) {
          .photo {
            background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/three-photo-two.png") no-repeat center
              center;
          }
        }
        li:nth-child(3) {
          .photo {
            background: url("http://theoneart-public.oss-cn-qingdao.aliyuncs.com/activity/three-photo-three.png") no-repeat center
              center;
          }
        }
      }
    }
  }
  .content-two {
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
    line-height: 48px;
    margin-top: 23px;
    text-align: center;
    p:nth-child(2) {
      margin-top: 44px;
      span {
        color: #f5b703;
      }
    }
  }
}
</style>
